// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"126":"[auth]","285":"[Home]","631":"[profile]"}[chunkId] + "." + {"126":"44a9227a","285":"a1370163","631":"c449434e"}[chunkId] + ".chunk.css";
};